<template>
  <v-card elevation="2" tile v-if="!editing && projeto">
    <v-card-title>
      <p>Projeto</p> 
    </v-card-title>
    <v-divider></v-divider>

    <v-card-text>
      <v-row class="mb-n6">
        <v-col>
          <span class="font-weight-bold text-uppercase">Título:</span>
          <p class="font-weight-light title ">
            {{ projeto.titulo }}
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <span class="font-weight-bold text-uppercase">Descrição:</span>
          <p class="font-weight-light title ">
            {{ projeto.descricao }}
          </p>
        </v-col>
      </v-row>

      <v-row class="mt-1">
        <v-col xl="3">
          <span class="font-weight-bold text-uppercase">Data de Início:</span>
          <p class="font-weight-light title ">
            {{ formatDate(projeto.inicio) }}
          </p>
        </v-col>
        <v-col xl="3">
          <span class="font-weight-bold text-uppercase">Data de Término:</span>
          <p class="font-weight-light title ">
            {{ formatDate(projeto.termino) }}
          </p>
        </v-col>
        <v-col xl="3">
          <span class="font-weight-bold text-uppercase">Data de Extensão:</span>
          <p class="font-weight-light title ">
            {{ projeto.extensao ? formatDate(projeto.extensao) : '-' }}
          </p>
        </v-col>
        <v-col xl="3">
          <span class="font-weight-bold text-uppercase">Duração em Meses:</span>
          <p class="font-weight-light title ">
            {{ duracaoEmMeses }}
          </p>
        </v-col>
      </v-row>

    </v-card-text>

    <v-card-actions class="mx-2 mt-n4">
      <v-btn v-if="isPermissao" @click.prevent="editing = true" small color="primary">Editar</v-btn>
      <v-btn v-if="isPermissao" small color="secondary" @click="excluir">Excluir</v-btn>
    </v-card-actions>

    <Confirm ref="confirm"></Confirm>

  </v-card>
  <ProjetoEditor v-else
      :projeto="projeto"
      @save="editing = false"
      @cancel="editing = false"
  />

</template>

<script>
import ProjetoEditor from "@/components/Projeto/ProjetoEditor";
import Confirm from "@/components/Dialog/Confirm";

import { mapActions } from "vuex";

export default {
  name: "ProjetoCard",
  components: {
    ProjetoEditor,
    Confirm
  },
  props: {
    projeto: {
      required: false,
      type: Object
    },
    isPermissao: {
      require: true
    }
  },

  computed: {
    duracaoEmMeses() {
      return this.$store.getters["projeto/getMeses"](parseInt(this.$route.params.projetoId)).length;
    }
  },

  data () {
    return {
      editing: false,
    }
  },
  methods: {
    ...mapActions("projeto", ["deletarProjeto"]),

    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    excluir() {
      this.$refs.confirm
        .open(
          'Excluir Projeto',
          '',
          "Você tem certeza?",
          {}
        )
        .then((confirm) => {
          if (confirm) {
            const projetoId = this.projeto.id
            this.deletarProjeto(projetoId)
              .then(() => {
                this.$router.push({ name: 'Projetos' })
              });
          }
        });
    },

  }
}
</script>

<style scoped>
</style>
